import { Component } from '@angular/core';
import { environment } from '@env/environment';

import { Router } from '@angular/router';
import { URLs } from '@constants/server_url';

@Component({
  selector: 'cd-header-banner',
  templateUrl: './banner.component.html',
  styleUrls: ['./banner.component.scss'],
})
export class HeaderBannerComponent {
  constructor(private router: Router) {}

  goToBuyToken() {
    document.querySelector('#BuyCoinDepoTokenNow')?.scrollIntoView({ behavior: 'smooth', block: 'start' });
  }

  openLendingTokenPage() {
    window.open(URLs[environment.env], '_blank');
  }
}
